import QRCodeVue from '@/views/sa/qr-code/qr-code.vue';

const basePath = '/sa/qr-code';
const role = 'sa'; // 角色身份

export const SA_QR_CODE_INDEX = 'sa-qr-code';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: QRCodeVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_QR_CODE_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/qr-code/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
